import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-paper-plane',
  templateUrl: './icon-paper-plane.component.html',
  styleUrls: ['./icon-paper-plane.component.scss'],
})
export class IconPaperPlaneComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
